<div class="modal-content">
  <div class="modal-header">
    <h4 class="modal-title">Toma de foto web</h4>
    <button type="button" class="close" (click)="cancel()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-8 col-md-6">
        <div class="btn-group mb-3">
          <button class="btn btn-outline-primary" type="button" [hidden]="toggleVideoFlag"
            (click)="toggleVideo(true)" title="Activar Cámara">
            <i class="fa fa-play"></i> Activar Cámara
          </button>
          <button class="btn btn-outline-primary" type="button" [hidden]="!toggleVideoFlag"
            (click)="toggleVideo(false)" title="Desactivar Cámara">
            <i class="fa fa-pause"></i> Desactivar Cámara
          </button>
          <button class="btn btn-outline-primary" type="button" (click)="capturePhoto()" title="Tomar Foto">
            <i class="fa fa-camera"></i> Tomar Foto
          </button>
          <button class="btn btn-outline-primary" type="button" (click)="deletePicture()" title="Limpiar">
            <i class="fa fa-trash"></i> Limpiar
          </button>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="row">
          <div class="col-12 col-md-12 col-sm-12 d-flex justify-content-center">
            <video class="border" #hardwareVideo width="640" height="480" [hidden]="pictureTaken"
              style="max-width: 640px; max-height: 480px;"></video>
            <canvas #takenCanvas class="border" width="640" height="480" [hidden]="!pictureTaken"
              style="max-width: 640px; max-height: 480px;"></canvas>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="cancel()">Cancelar</button>
    <button type="button" class="btn btn-outline-primary" (click)="handleSaveClick()">Guardar</button>
  </div>
</div>
